'use strict';

define('components/offers/offers-strip',[
  'jquery',
  'lib/util/langFromUrl',
  'lib/getParameterByName',
  'lib/util/tda.config',
  'lib/util/zip',
  'lib/page-cache',
  'components/slicker',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'features/favorites',
  'lib/scroller',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'cookies',

  // side effect includes
  'lib/helpers/offer-bundle',
  'jqueryui',
  'Handlebars',
  'bat'
], function (
  $,
  langFromUrl,
  getParamByName,
  tdaConfig,
  zip,
  PageCache,
  Slicker,
  offersServiceFactory,
  xformOffersCommon,
  favorites,
  scroller,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  cookies
) {
  var offersService = offersServiceFactory(tdaConfig.offers.r2_api_key);
  var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';
  var __seriesMap;
  var offerStrip;

  // seriesString is optional
  // resolves with an array of series or null
  // offerid in QS trumps all other series determining
  function __addSeries(seriesString) {
    return new Promise(function (resolve) {
      var offerDetail = getParamByName('offerid');
      if (offerDetail) {
        PageCache.await('offer.results.' + offerDetail)
          .then(function (res) {
            // do ALL offers have this on them? I believe so... but test
            if (res.offerBundle && res.offerBundle.offers.length) {
              var seriesList = res.offerBundle.offers[0].seriesList;
              if (seriesList && seriesList.series.id) {
                resolve([seriesList.series.id]); // return as array. sorry
              }
            } else {
              resolve(null);
            }
          })
          .catch(function (err) { offerStrip.handleErrors(err); });
      } else if (seriesString) {
        var arr = seriesString.split(',').map(function (item) {
          return item.trim();
        });
        resolve(arr);
      } else {
        resolve(null);
      }
    });
  }

  offerStrip = {
    /*
      Note: Even though '.component-strip-offer' may exist on offer-detail based RAQ forms,
      This init is NOT invoked. Init is invoked only from within the offers-strip.xsl
      while messy, this is a good thing...
      as we don't want to do offers-strip things unless there's an ACTUAL
      offers-strip COMPONENT in the DOM

      TODO:
      - Account for useLabelCode, useOfferType, useLabelCode, zipCode, etc datum configs.
      - what is 'useSeriesCode supposed to do? All the vehicle info pages have it
        set to 'no', and instead provide the seriescode in the series datum directly
    */
    init: function (el, config) {
      var self = this;
      self.$el = $(el);
      self.$strip = $('.offer-cards-slider', self.$el);
      self._config = config;
      self.config = config;

      // wait for seriesMap
      PageCache.await('series.map')
        .then(function (seriesMap) {
          __seriesMap = seriesMap;
          self.load();
        })
        .catch(function (err) {
          self.handleErrors(err);
        });
    },

    load: function () {
      var self = this;
      var params = self.config.params;
      var defaultSeries = self.defaultSeries();

      // a bit messy, need to do this to see if we have an offer detail
      // if we do, that's how we get our series for the offers strip
      __addSeries(defaultSeries)
        .then(function (res) {
          if (res) self.series = res;
          self.pageSize = params.pageSize ? params.pageSize : '9999';
          self.drawHeading(self.buildHeading());
          self.getOffers();
        })
        .catch(function (err) {
          self.handleErrors(err);
        });
    },

    // we need to determine what series to use
    // what param should actually win against the others?
    // I say if it came with a series datum, that trumps all others
    defaultSeries: function () {
      var params = this.config.params;
      var detectQueries = (params.detectQueries === 'true');
      if (params.series) {
        return params.series;
      }
      if (detectQueries) {
        return getParamByName('series');
      }
      return null;
    },

    buildHeading: function () {
      var custom = this._config.params.customHeading;
      if (custom) {
        return custom;
      }
      if (this.series && this.series.length) {
        var displaySeries = __seriesMap[this.series[0]].series_display_name;
        var configTitle = this._config.i18n.hasSeriesTitle;
        return displaySeries + ' ' + configTitle;
      }
      return this._config.i18n.defaultTitle;
    },

    drawHeading: function (heading) {
      $('.offer-strip-title', this.$el).html(heading);
    },

    getOffers: function () {
      var self = this;
      var cacheId = 'offer.strip';
      var request = {
        tdaCode: tdaConfig.tda.code,
        zipCode: zip.getCookiedDefaultFallback(),
        lang: langFromUrl(),
        pageSize: self.pageSize
      };

      if (self.series) {
        request.series = self.series.toString(); // avalon,avalonhybrid... relies on proper datum config (always has))
      }

      if (!PageCache.hasOrPending('offers.strip')) {
        PageCache.maybeSet(cacheId, offersService.offers().all(request));
      }

      PageCache.await(cacheId)
        .then(function offerStripRes(res) {
          if (!res.containsOffers) {
            self.throwErrors(res.error);
          }
          return xformOffersCommon(res.offerBundle.offers);
        })
        .then(function (offersCommon) {
          self.appendOffers(offersCommon);
        })
        .catch(function (err) {
          self.handleErrors(err);
        });
    },

    // TODO: do we need to hide these appends until slideshow built?
    // so far, nope
    // note: we lose the 'id' on each offer card parent anchor, due to slick taking it over
    appendOffers: function (offers) {
      var tmplOfferCard = Handlebars.compile($('#template-offer-card').html());
      this.$strip.append(tmplOfferCard({ items: offers }));
      // TODO: why lazy on the lazy configs?
      $('img.lazy-v', this.$el).lazy({
        afterLoad: function ($el) {
          $el.css({ visibility: 'visible' });
        }
      });
      this.drawOffersSlider();
      this.addOfferContext(offers);
      this.favListeners();
    },

    drawOffersSlider: function () {
      return new Slicker({
        $slider: this.$strip,
        slickOptions: {
          mobileFirst: true,
          slide: '.card',
          slidesToShow: 1.4,
          slidesToScroll: 1,
          infinite: false,
          autoplay: false,
          dots: true,
          paddingBottom: 60,
          tablet: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      });
    },

    addOfferContext: function (offers) {
      var self = this;
      var $scope = self.$el;

      // add offer related context
      anAddContext(
        $scope,
        blocks.offerListBlock({
          count: offers.length,
          layout: 'strip'
        }),
        blocks.sectionBlock('Offers Strip')
      );

      if (self.series) {
        anAddContext(
          $scope,
          blocks.seriesBlock({
            series_code: self.series[0]
          })
        );
      }

      // offers context for each
      offers.forEach(function eachOfferCtx(offer) {
        anAddContext(
          $('a[href$="' + offer.id + '"]').parent('div.card-content'),
          blocks.offerBlock(offer)
        );
      });

      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });

      anClicks($scope);
    },

    // aarghh, kinda
    favListeners: function () {
      var $favButton = $('.favorite-button', this.$el);
      if (__hasRtiDealer) {
        $favButton.hide();
      } else {
        $favButton.each(function () {
          var $this = $(this);
          favorites.markFav($this);
          $this.on('click', function favClick(e) {
            e.preventDefault();
            favorites.addRemove($this);
          });

          PageCache.on('favs.store', function () {
            favorites.toggleFav($this);
          });
        });
      }
    },

    throwErrors: function throwErr(err) {
      if (err && err[0] === 'Mismatch zip and tda code entered.') {
        throw new Error('zip_mismatch');
      }
      throw new Error('no_offers');
    },

    // todo: just drop offers-strip from page if ANY error at all!?
    handleErrors: function handleErr(err) {
      console.error('err: ', err.name, err.message); // eslint-disable-line no-console
    },
  };
  return offerStrip;
});

